import { loginWithEmailAndPassword, getEmployeeForMobileAuth } from "../../api/signin/index";

export const loginUserWithEmailAndPasswordCredentials = async (payload: any) => {
  const response = await loginWithEmailAndPassword(payload);
  return response;
};

export const fetchEmployeeForMobileAuth = async (userId: string) => {
  const response = await getEmployeeForMobileAuth(userId);
  return response;
};